import React, { useEffect, useState } from 'react';
import DetailRow, { DetailRowProps } from './CustomComponents/DetailRow';
import MarcoStatus from './CustomComponents/AutoScoreStatus/AutoScoreStatus';
import { useConnectHub, useHubConnection } from 'CustomHooks';
import { useDisconnectHub } from 'CustomHooks/useHubConnection';
import MarcoService from 'business/services/MarcoService';

export default function IntegeratedDevice() {
  const [list, setList] = useState<DetailRowProps[]>([]);
  const [showMarcoStatus, setShowMarcoStatus] = useState<boolean>(false);
  const [autoScoreConnected, setAutoScoreConnected] = useState<boolean>(false);
  const marcoService = new MarcoService();
  const connection = useHubConnection();
  const disconnectHub = useDisconnectHub();
  const onConnectionStart = () => {
      connection.on('SetAutoScoreConnectedStatus', (data) => {
        setAutoScoreConnected(data);  
    });
  }

  useEffect(() => {
    useConnectHub(connection, onConnectionStart);
    return () => {
      disconnectHub(connection);
    };
  }, []);

  useEffect(() => {
    setList((prevList) =>
      prevList.map((item) => ({
        ...item,
        endingIcon: {
          name: autoScoreConnected ? 'Integrated_Active' : 'Integrated_Offline',
        },
      })),
    );
  }, [autoScoreConnected]);

  useEffect(() => {
    marcoService.isMarcoModelAvailable().then((res) => setAutoScoreConnected(res));
    setList([
      {
        text: 'Auto Score',
        startingIcon: { name: 'AutoScoreThreshold', fill: '#474747' },
        endingIcon: {
          name: autoScoreConnected ? 'Integrated_Active' : 'Integrated_Offline',
        },
        backGroundClr: 'white',
        fontClr: 'black',
        endingIconWidthHeight: 10,
        onClick: () => {
          setShowMarcoStatus(true);
        },
      },
    ]);
  }, []);
  function getRows() {
    const render = [];
    list.map((l, index) => {
      l.rowClassName = 'IntegratedDevicesDetailRow';
      render.push(<DetailRow key={`integrated-device-${index}`} {...l} />);
    });
    return render;
  }
  return (
    <div id='integeratedevice-get-rows-container' className="integratedDevice sectionBorder">
      <MarcoStatus showModal={showMarcoStatus} setShowModal={setShowMarcoStatus} />
      <div id='integeratedevice-grid-header' className="gridColumnHeader">Integrations</div>
      <div id='integeratedevice-body' className="integratedDeviceBody">{getRows()}</div>
    </div>
  );
}
